import React, { useState, useEffect } from 'react'
import { useParams } from "react-router-dom";
import { useHistory, useLocation } from "react-router-dom"
import { Box } from '@mui/material'
import { PostLogin } from '../../layout'
import { MuiButton } from '../../components'
import DataGridTable from './dataGridTable'
import RowDetails from './rowDetails'
import Filter from './filter'
import { ROUTE_INITIATE_PROJECTS, ROUTE_INITIATE_PROJECTS_DRAFTS, ROLES_ALL, ROLES_CLIENT_PRIMARY, ROLES_CLIENT_SECONDARY } from '../../constants'
import { NAME_HELP, ROUTE_REPORTS } from '../../constants'

import { IconDraft, IconPlus } from '../../assets/images/iconsV2'
import { ROLES_JUNIOR_ANALYST } from '../../constants'
import { clearLocalStorageOldData, removeCSVLocalStorage } from '../../util'
import { BlockingLoader } from '../../components'


import ProjectsService from '../../services/projects.service'
import GenerativeService from '../../services/generative.service'
import reportsService from '../../services/reports.service'


import { Wrapper, InnerWrapper } from './style'
import { useGlobalStore } from '../../store'

const ProjectsV2 = (props) => {
  const { isAskIaPage } = props
  const {
    user,
    setLoadAllLhs,
    setCSVSubLhs,
    setPPTSubLhs,
    setPPTSubLhsAppendices,
    setPPTSubLhsProgression,
    setShowLhsMenu,
    setAskIaActiveState,
    setExportToPptObject,
    setExportToCsvObject,
    setCSVModalActive,
    setPPTModalActive,
    setPPTModalActiveAndClicked,
  } = useGlobalStore()

  const browseWidth = Math.round((window.screen.width - (110 + 60 + 50)) / 4)

  const [projectsLoading, setProjectsLoading] = useState(false)
  const [projectsLoadingDetails, setProjectsLoadingDetails] = useState(false)
  const [gridRowOriginal, setGridRowOriginal] = useState([])
  const [gridRow, setGridRow] = useState([])
  const [rowArray, setRowArray] = useState(null)
  const [showRHS, setShowRHS] = useState(false)
  const [showAskIaDetail, setShowAskIaDetail] = useState(false)
  const { id } = useParams()
  const history = useHistory()
  const location = useLocation()
  const navigate = useHistory()

  const [gridColumns, setGridColumns] = useState([
    {
      field: '',
      width: '30px',
      align: 'left',
      sortKey: 'logoName',
      sort: null,
    },
    {
      field: 'Brand/Category',
      width: browseWidth,
      align: 'left',
      sortKey: 'BrandName',
      sort: null,
    },
    {
      field: 'Project Type',
      width: browseWidth,
      align: 'left',
      sortKey: 'ProjectType',
      sort: null,
    },
    { field: 'Market', width: browseWidth, align: 'left', sortKey: 'MarketName', sort: null },
    {
      field: 'Last Updated',
      width: browseWidth,
      align: 'left',
      sortKey: 'ModifiedDate',
      sort: null,
    },
  ])

  const [accordionHeading, setAccordionHeading] = useState([
    { field: 'Brand/Category', sortKey: 'BrandName', data: [], filterIndex: [] },
    { field: 'Project Type', sortKey: 'ProjectType', data: [], filterIndex: [] },
    { field: 'Market', sortKey: 'MarketName', data: [], filterIndex: [] },
  ])

  const updateFilter = (obj = {}) => {
    const heading = accordionHeading.map((a) => {
      if (Object.keys(obj).includes(a.sortKey)) {
        a.data.map((d) => {
          if (d[a.sortKey] === obj[a.sortKey]) {
            d.checked = obj.checked
            if (obj.checked) {
              a.filterIndex.push(d[a.sortKey])
            } else {
              const ind = a.filterIndex.indexOf(d[a.sortKey])
              a.filterIndex.splice(ind, 1)
            }
          }
          return d
        })
      }
      return a
    })

    let tempRow = []
    for (let r = 0; r < gridRowOriginal.length; r++) {
      if (
        heading[0].filterIndex.includes(gridRowOriginal[r].BrandName) ||
        heading[1].filterIndex.includes(gridRowOriginal[r].ProjectType) ||
        heading[2].filterIndex.includes(gridRowOriginal[r].MarketName)
      ) {
        tempRow.push(gridRowOriginal[r])
      }
    }
    setGridRow(tempRow.length ? tempRow : gridRowOriginal)

    const gridColumn = gridColumns.map((c) => {
      c.sort = null
      return c
    })
    setGridColumns(gridColumn)
    setAccordionHeading(heading)
  }

  const selectAllFilter = (flag, key) => {
    const heading = accordionHeading.map((a) => {
      if (a.sortKey === key) {
        a.data = gridRowOriginal
          .map((f) => f[a.sortKey])
          .filter((value, index, self) => self.indexOf(value) === index)
          .map((d) => {
            return { [a.sortKey]: d, checked: flag }
          })

        a.filterIndex = flag ? a.data.map((d) => d[a.sortKey]) : []
      }
      return a
    })

    let tempRow = []
    for (let r = 0; r < gridRowOriginal.length; r++) {
      if (
        heading[0].filterIndex.includes(gridRowOriginal[r].BrandName) ||
        heading[1].filterIndex.includes(gridRowOriginal[r].ProjectType) ||
        heading[2].filterIndex.includes(gridRowOriginal[r].MarketName)
      ) {
        tempRow.push(gridRowOriginal[r])
      }
    }
    setGridRow(tempRow.length ? tempRow : gridRowOriginal)

    setAccordionHeading(heading)
  }

  const resetFilter = () => {
    const heading = accordionHeading.map((a) => {
      a.data.map((d) => {
        d.checked = false
        return d
      })
      a.filterIndex = []
      return a
    })

    let tempRow = []
    for (let r = 0; r < gridRowOriginal.length; r++) {
      if (
        heading[0].filterIndex.includes(gridRowOriginal[r].BrandName) ||
        heading[1].filterIndex.includes(gridRowOriginal[r].ProjectType) ||
        heading[2].filterIndex.includes(gridRowOriginal[r].MarketName)
      ) {
        tempRow.push(gridRowOriginal[r])
      }
    }
    setGridRow(tempRow.length ? tempRow : gridRowOriginal)

    const gridColumn = gridColumns.map((c) => {
      c.sort = null
      return c
    })
    setGridColumns(gridColumn)
    setAccordionHeading(heading)
  }

  const searchFilter = (searchValue) => {
    updateFilter()
    if (searchValue) {
      const lowerSearch = searchValue.toLowerCase()

      const searchData = gridRow.filter(
        (s) =>
          s.BrandName?.toLowerCase().match(lowerSearch) ||
          s.ProjectType?.toLowerCase().match(lowerSearch) ||
          s.MarketName?.toLowerCase().match(lowerSearch)
      )
      setGridRow(searchData)
    }
  }

  const gettingUniqueFilterCategoryData = () => {
    const heading = accordionHeading.map((a) => {
      a.data = gridRowOriginal
        .map((f) => f[a.sortKey])
        .filter((value, index, self) => self.indexOf(value) === index)
        .map((d) => {
          // return { [a.sortKey]: d, checked: true }
          return { [a.sortKey]: d, checked: false }
        })

      // a.filterIndex = a.data.map(d => d[a.sortKey])
      return a
    })
    setAccordionHeading(heading)
  }

  const getRowDetailData = (param) => {
    const dataLength = gridRowOriginal.find((data) => data.ProjectId === param.projectId).details

    const applyRoles = (data) => {
      if (data?.length > 0) {
        return data?.map((d) => {
          if (d?.lhs?.length > 0 && [ROLES_JUNIOR_ANALYST].includes(user.UserType)) {
            d.lhs = d.lhs.filter((f) => f.TabIcon === 'sandbox')
            d.href = `/reports/${d.lhs[0].TabIcon}/${d.lhs[0].StudyId}`
          }
          return d
        })
      }
      return data
    }

    const rowData = gridRow.map((d) => {
      if (d.ProjectId === param.projectId) d.isVisible = !d.isVisible
      return d
    })
    setGridRow(rowData)

    if (dataLength.length === 0) {
      setProjectsLoadingDetails(true)
      ProjectsService.projectsDetailApi(param)
        .then((resp) => {
          const rowDataOriginal = gridRowOriginal.map((d) => {
            if (d.ProjectId === param.projectId) {
              d.details = applyRoles(resp)
            }
            return d
          })
          setGridRowOriginal(rowDataOriginal)

          const rowData = gridRow.map((d) => {
            if (d.ProjectId === param.projectId) {
              d.details = applyRoles(resp)
              d.isVisible = true
              setShowRHS(true)
            }
            return d
          })

          const finalRowData = rowData.map((d) => {
            if (d.ProjectId === param.projectId) {
            } else {
              d.details = []
              d.isVisible = false
            }
            return d
          })
          setGridRow(finalRowData)

          const heading = accordionHeading.map((a) => {
            a.data.map((d) => {
              if (a.filterIndex.includes(d.BrandName)) {
                d.checked = true
              }
              return d
            })
            return a
          })
          setAccordionHeading(heading)

          setProjectsLoadingDetails(false)
        })
        .catch((error) => {
          const resMessage = error
          console.log('ERROR : ', resMessage)
          setProjectsLoadingDetails(false)
        })
    }
  }

  const checkAskIaFunc = () => {
    if(!isAskIaPage) return false
    console.log(id);
    setShowAskIaDetail(true)
  }

  const redirectToAskIaPageFunc = () => {
    const params = new URLSearchParams(location.search);
    const insightId = params.get("askia");

    // https://staging-ia.mavenmagnet.com/projects?askia=371e3996-0b9a-4271-a813-92926c635c72 (INSIGHTS_ID) // MAHINDRA PROJECT
    // https://staging-ia.mavenmagnet.com/projects?askia=8d196eb4-e378-11ed-817c-0a1ea4c5532f (INSIGHTS_ID) // MMTEST PROJECT

    // http://localhost:8080/projects?askia=371e3996-0b9a-4271-a813-92926c635c72 (INSIGHTS_ID) // MAHINDRA PROJECT
    // http://localhost:8080/projects?askia=8d196eb4-e378-11ed-817c-0a1ea4c5532f (INSIGHTS_ID) // MMTEST PROJECT
    // http://localhost:8080/reports/background/475820ee-6e3a-11ef-8482-128e718ba88f
 
    // http://localhost:8080/projects?askia=44ab0240-d9bd-40d4-8500-fb27d07d6a37 // MAHINDRA PROJECT
    // http://localhost:8080/reports/executivesummary/473dd993-02fc-11f1-b8a9-128e718ba88f (STUDY_ID) // Thar ROXX | Brand Pulse
    // 

    // FILES USED projectV2.js, reports.js, reportGenerative.js, headerButtons.js

    if(insightId) {
      const payload = {insightsElementIds:{guid: insightId}}
      GenerativeService.getInsightsElementsAcrossStudiesApi(payload)
        .then((respSoap) => {

          // UPDATING GetStudies
          
          const resp0 = respSoap?.[0].InsightsElement
          window.localStorage.setItem("askIaInsightsId", JSON.stringify(resp0));

          if(resp0?.StudyId === undefined){
            console.log('================================')
            console.log('================================')
            console.log('======= CHECK INSIGHTs ID ======')
            console.log('================================')
            console.log('================================')
          } else {
            reportsService.reportGetCompanyIdProjectIdForStudyId({ studyId: resp0.StudyId })
              .then((resp2) => {
                console.log('=========================', resp2)

                const ls = JSON.parse(window.localStorage.company)
                console.log('resp2[0].CompanyId----ls.CompanyId ======================', resp2[0].CompanyId !== ls.CompanyId, resp2[0].CompanyId, ls.CompanyId)

                if(ls.CompanyId === 'e0804536-45e9-11ed-bca4-0a1ea4c5532f'){
                  // resp2 = [{
                  //   CompanyId: ls.CompanyId,
                  //   ProjectId: 'bf88275d-54fe-11ed-817c-0a1ea4c5532f'
                  // }]
                  console.log('----------', resp2)
                } else if(resp2[0].CompanyId !== ls.CompanyId){
                  navigate.push(`/?askia=${insightId}`)
                  return false
                }

                reportsService.reportGetStudies({ projectId: resp2[0].ProjectId })
                  .then((resp3) => {
                  
                    reportsService
                      .reportLhsApi({ studyId: resp0.StudyId })
                      .then((resp4) => {
                        const sortedRespData = resp4
                          .sort((a, b) => a.TabOrder - b.TabOrder)
                          .filter((f) => f.TabVisible)

                              // brandName: headerLogData?.BrandName || headerLogData?.CategoryName || '',
                              // breadCrumb: headerLogData?.ProjectType || '',
                              // projectType: `${headerLogData?.ProjectType || ''}${headerLogData?.ProjectType ? ',' : ''} ${headerLogData?.MarketName || ''}`,

                              const modifiedData = sortedRespData.filter(f => f.TabOrder ===  1).map((list) => {
                                list.userType = list.TabIcon === 'sandbox' ? ROLES_ALL : ROLES_CLIENT_SECONDARY
                                list.title = list.TabName
                                list.label = list.TabName
                                list.href = `/reports/${list.TabIcon}/${resp0.StudyId}?askiaInsightsId=${insightId}&title=${resp0.Title}`

                                return list
                              })[0]

                        navigate.push(modifiedData.href)

                      })
                      .catch((error) => {
                        const resMessage = error
                        console.log(resMessage)
                      })

                  })
              })
          }
        })
        .catch((error) => {
          console.log('ERROR : ', error)
        })
    }
  }

  useEffect(() => {
    if (gridRowOriginal?.length === 0 && user?.UserId) {
      clearLocalStorageOldData()
      setProjectsLoading(true)
      ProjectsService.projectsApi({ user: user }, true)
        .then((resp) => {
          const data = resp.map((r) => {
            r.details = []
            r.BrandName = r.BrandName === '' ? r.CategoryName : r.BrandName
            r.isVisible = false
            return r
          })
          const filteredData = data.filter((item) => !item?.IsDraft)
          setGridRowOriginal(filteredData)
          setGridRow(filteredData)
          setProjectsLoading(false)
        })
        .catch((error) => {
          const resMessage = error
          console.log('ERROR : ', resMessage)
          setProjectsLoading(false)
        })
    }
  }, [user])

  useEffect(() => {
    gettingUniqueFilterCategoryData()
  }, [gridRowOriginal])

  useEffect(() => {
    setLoadAllLhs([])
    setCSVSubLhs([])
    setPPTSubLhs([])
    setPPTSubLhsAppendices([])
    setPPTSubLhsProgression([])

    setShowLhsMenu('projectPage')

    window.localStorage.removeItem('AskIaData')
    window.localStorage.removeItem('askIaLoading')
    window.localStorage.removeItem('askIaStartServer')
    setAskIaActiveState('none')
    setCSVModalActive(false)
    setPPTModalActive(false)
    setPPTModalActiveAndClicked(false)

    setExportToPptObject({})
    setExportToCsvObject({})

    removeCSVLocalStorage('csv___')

    checkAskIaFunc()
    setTimeout(() => {
      redirectToAskIaPageFunc()
    }, 1000)
  }, [])

  useEffect(() => {
    const filterData = gridRow.find((row) => row.isVisible) || null
    setRowArray(filterData)
  }, [gridRow])

  let memberAccess = user.CanInitiateNewProject

  if ([ROLES_JUNIOR_ANALYST].includes(user.UserType)) {
    memberAccess = false
  }

  const HeaderButtons = () => {
    return (
      <>
        {memberAccess && (
          <Box id='BtnDraft'>
            <MuiButton
              label='Draft'
              startIcon={<IconDraft />}
              variant='outlined'
              color='dark'
              size='small'
              to={ROUTE_INITIATE_PROJECTS_DRAFTS}
            />
          </Box>
        )}
        {memberAccess && (
          <Box id='BtnInitiateNewProject'>
            <MuiButton
              label='Initiate New Project'
              startIcon={<IconPlus />}
              variant='contained'
              color='primary'
              size='small'
              to={ROUTE_INITIATE_PROJECTS}
            />
          </Box>
        )}
      </>
    )
  }

  return (
    <PostLogin pageTitle='Projects' activePage='projects' actions={<HeaderButtons />}>
      <Wrapper>
        <InnerWrapper>
          {!!gridRowOriginal?.length && accordionHeading && (
            <Filter
              accordionHeading={accordionHeading}
              onChange={updateFilter}
              onSearch={searchFilter}
              onReset={resetFilter}
              onChangeSelectAll={selectAllFilter}
              showRHS={showRHS}
            />
          )}
          <DataGridTable
            columns={gridColumns}
            rows={gridRow}
            loading={projectsLoading}
            loadingDetails={projectsLoadingDetails}
            sortingBy=''
            getRowDetailData={getRowDetailData}
          />
        </InnerWrapper>

        {showRHS && rowArray?.details?.length > 0 && <RowDetails row={rowArray} />}
        {/* {isAskIaPage && showAskIaDetail && <AskIaDetail />} */}

        {projectsLoadingDetails && <BlockingLoader />}
      </Wrapper>
    </PostLogin>
  )
}

export default ProjectsV2
